import React from 'react'

function Players() {
  return (
    <div>Players</div>
  )
}

export default Players